mutation UpdateMfaRequiredSetting($input: MfaUpdateRequiredSettingInput!) {
    mfaUpdateRequiredSetting(input: $input) {
        success
    }
}
